import { Button, ButtonRow } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import type { IQuestionnaireFormProps } from '../../../Questionnaire';
import { essQuestionOptions } from '../../../../../../../common/validation/customControls/somnology';
import { Step } from '../../../../../elements/atoms/step/Step';
import { CustomContainer } from '../../../../../elements/molecules/customContainer/CustomContainer';
import { Stack } from '../../../../../elements/molecules/stack/Stack';
import { PageIntro } from '../../../../../elements/organisms/pageIntro/PageIntro';
import { QuestionnaireRadioGroup } from '../../../../../elements/organisms/questionnaireRadioGroup/QuestionnaireRadioGroup';
import { StyledFormGroup } from '../../../../../elements/organisms/StyledFormGroup/StyledFormGroup';

export function Step2(props: IQuestionnaireFormProps) {
    const [isSaving, setIsSaving] = useState<boolean>(false);

    useEffect(() => {
        if (props.errors.size === 0) {
            setIsSaving(false);
        }
    }, [props.errors.size]);

    return (
        <>
            <PageIntro title="ESS: vragen deel 2/2" />

            <CustomContainer>
                <Stack>
                    <Step>5/8</Step>
                    <StyledFormGroup
                        hasErrors={props.errors.has('restingInTheAfternoon')}
                        label="Wanneer ik 's middags even ga liggen rusten als de omstandigheden het toelaten"
                        layout="vertical"
                    >
                        <QuestionnaireRadioGroup
                            {...props}
                            customControlData={props.procedure.customControlData}
                            customControlKey="restingInTheAfternoon"
                            questionnaireOptions={essQuestionOptions}
                        />
                    </StyledFormGroup>
                </Stack>

                <Stack>
                    <Step>6/8</Step>
                    <StyledFormGroup
                        hasErrors={props.errors.has('talkingToSomeone')}
                        label="Wanneer ik met iemand zit te praten"
                        layout="vertical"
                    >
                        <QuestionnaireRadioGroup
                            {...props}
                            customControlData={props.procedure.customControlData}
                            customControlKey="talkingToSomeone"
                            questionnaireOptions={essQuestionOptions}
                        />
                    </StyledFormGroup>
                </Stack>

                <Stack>
                    <Step>7/8</Step>
                    <StyledFormGroup
                        hasErrors={props.errors.has('afterLunch')}
                        label="Wanneer ik op mijn gemak zit na een lunch zonder alcohol"
                        layout="vertical"
                    >
                        <QuestionnaireRadioGroup
                            {...props}
                            customControlData={props.procedure.customControlData}
                            customControlKey="afterLunch"
                            questionnaireOptions={essQuestionOptions}
                        />
                    </StyledFormGroup>
                </Stack>

                <Stack>
                    <Step>8/8</Step>
                    <StyledFormGroup
                        hasErrors={props.errors.has('waitingInTheCarInTraffic')}
                        label="Wanneer ik in de auto zit, terwijl ik enkele minuten stil sta in het verkeer"
                        layout="vertical"
                    >
                        <QuestionnaireRadioGroup
                            {...props}
                            customControlData={props.procedure.customControlData}
                            customControlKey="waitingInTheCarInTraffic"
                            questionnaireOptions={essQuestionOptions}
                        />
                    </StyledFormGroup>
                </Stack>
                <ButtonRow justify="right">
                    <Button
                        color="secondary"
                        isDisabled={isSaving}
                        onClick={async () => {
                            setIsSaving(true);
                            if (props.submit) {
                                await props.submit();
                            }
                        }}
                        variant="solid"
                        width="full-below-small"
                    >
                        Verzenden
                    </Button>
                </ButtonRow>
            </CustomContainer>
        </>
    );
}
